import { Box, SxProps } from "@mui/material";
import { useGetOnboardQuery } from "src/context/api/onboard/api";
import { usePathname } from "src/routes/hooks";
import BannersGrid from "src/sections/overview/dashboards/views/admin/onboard/grid";

export default function Section({ children, ...other }: { children: React.ReactNode } & {sx?: SxProps}) {
    const pathname = usePathname();
    const { data: allBanners, refetch } = useGetOnboardQuery();
    const banners = allBanners?.filter((banner) => banner.target === pathname);

    const routes = [
        "/brand-overview",
        "/optimization/campaigns",
        "/optimization/activations/active-mode",
        "/optimization/scraping",
        "/optimization/activations/ko-bidding/max-cpc",
        "/optimization/activations/ko-bidding/troas",
        "/optimization/activations/ko-bidding/tcpa",
        "/optimization/activations/ko-bidding/target-impression-share",
        "/optimization/activations/ko-bidding-auto",
        "/brand-wayback",
        "/admin/users",
        "/admin/users/add",
        "/workspaces",
        "/workspaces/add",
        "/admin/features/live-bidding/ad-group-based",
        "/"
    ];

    const isSpecialRoute = routes.includes(pathname) || window.location.pathname.startsWith("/workspaces/") || window.location.pathname.startsWith("/competitor/");

    return (
        <Box className="section-banner-app-wrapper" sx={{ pt: isSpecialRoute ? 16 : 22, pb: 2, ...other.sx }}>
            <Box>
                <BannersGrid
                    banners={banners || []}
                    edit={false}
                    dismiss={true}
                    onDismiss={refetch}
                />
            </Box>

            {children}
        </Box>
    );
}
